import createIcon from '../../createIcon';

/**
 * @component @name PowerOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMjkgMTMuOTlWOC41QzE4LjI5IDcuNSAxNy4yOCA2LjQ5IDE2LjI5IDYuNVYyLjVIMTQuMjlWNi41SDEwLjI5VjIuNUg4LjI5VjQuOThMMTcuOCAxNC40OEwxOC4yOSAxMy45OVpNMTYuNTMgMTUuNzZMNy40OSA2LjdMNy40OCA2LjcxTDQuMjcgMy41TDMgNC43NUw2LjM2IDguMTFDNi4zMyA4LjI0IDYuMjkgOC4zNyA2LjI5IDguNVYxMy45OEw5Ljc5IDE3LjVWMjAuNUgxNC43OVYxNy41TDE1LjI3IDE3LjAyTDE5Ljc0IDIxLjVMMjEgMjAuMjJMMTYuNTMgMTUuNzZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PowerOff = createIcon('PowerOff', [
  [
    'path',
    {
      d: 'M18.29 13.99V8.5C18.29 7.5 17.28 6.49 16.29 6.5V2.5H14.29V6.5H10.29V2.5H8.29V4.98L17.8 14.48L18.29 13.99ZM16.53 15.76L7.49 6.7L7.48 6.71L4.27 3.5L3 4.75L6.36 8.11C6.33 8.24 6.29 8.37 6.29 8.5V13.98L9.79 17.5V20.5H14.79V17.5L15.27 17.02L19.74 21.5L21 20.22L16.53 15.76Z',
      key: '2cpjl2',
    },
  ],
]);

export default PowerOff;
